import { render, staticRenderFns } from "./StaffpayHistory.vue?vue&type=template&id=68046264&"
import script from "./StaffpayHistory.vue?vue&type=script&lang=js&"
export * from "./StaffpayHistory.vue?vue&type=script&lang=js&"
import style0 from "./StaffpayHistory.vue?vue&type=style&index=0&id=68046264&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports